import type { CategoryQuerySchema } from './category-query-schema';

export const categoryOptions = [
  { id: '-1', name: 'All' },
  { id: 'Basic Knowledge', name: 'Basic Knowledge' },
  { id: 'Understanding', name: 'Understanding' },
  { id: 'Application', name: 'Application' },
  { id: 'Analysis', name: 'Analysis' },
  { id: 'Evaluation', name: 'Evaluation' },
];

export const defaultCategory: CategoryQuerySchema = categoryOptions[0];
